import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import nissan from "../../../../assets/info/nissan-patrol/patrol-hero.jpg";
import castor from "../../../../assets/info/nissan-patrol/patrol-bushes_1.jpg";
import y60 from "../../../../assets/info/nissan-patrol/patrol-y60-drag-link.jpg";
import y61 from "../../../../assets/info/nissan-patrol/patrol-y61-drag-link.jpg";
import styled from "styled-components";
import { Link } from "react-router-dom";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const NissanPatrol = () => {
  useSmallNav("Nissan Patrol");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan Patrol"} bolder />
        <InfoHero image={nissan} />
        <InfoGrid>
          <div>
            <p>
              When off-road folk talk about the ultimate off-road vehicles, two
              vehicles are usually at the top of the list for reliability and
              capability when off-roading..
            </p>
            <InfoHeader text={"The Toyota Landcruiser and the Nissan Patrol"} />
            <p>
              The Nissan Patrol has been around since 1951, almost as long as
              Pedders Suspension! We love the reliability and capability of this
              big 4x4. They're made even better by fitting Pedders Suspension
              products creating an almost unstoppable 4x4.
            </p>
            <p>
              Trak Ryder 4WD Suspension represents many years of technical
              development and delivers new levels of ride and comfort for the
              4-wheel drive Nissan Patrol owner. Pedders Trak Ryder suspension
              includes hundreds of quality components in its construction each
              designed to improve the ride and handling of specific vehicles in
              specific ways.
            </p>
            <p>
              There are many different versions of the Patrol, starting from the
              up to G60 series, MQ, MK, Y60 and Y61, LWB and SWB. Each Patrol
              has it's own suspension design, capabilities and fables and we
              offer many parts to upgrade, lift or simply maintain your Patrol.
            </p>
            <InfoHeader
              text={'The first question is "What do I want from my Patrol?'}
            />
            <p>
              If you're wanting to put your 4x4 to the test, lift the
              suspension, gain more axle articulation, fit bigger tyres etc,
              check out the "Lift Kits".
            </p>
            <p>
              If you constantly tow or load your Patrol, an upgrade in standard
              height or lifted rear suspension will give you a more stable
              vehicle capable of taking more weight without suffering from
              suspension which is unable to control the vehicle.
            </p>
            <p>
              If you are a spirited driver, maybe you want to retain the
              standard height but stiffen everything up to give you more
              feedback, better handling characteristics and control. We cater
              for all.
            </p>
            <p>
              Please choose your vehicle from the selection and should you have
              any questions, feel free to ask us on our Live Chat.
            </p>
            <InfoHeader text={"How high will my Patrol be?"} />
            <p>
              Although the kits give an approximate lift, this can be a little
              misleading. Springs settle over time, so a 1.5 inch lift, may turn
              out to be a bit more in reality. To ensure that you know exactly
              what you are getting, we quote a fitted height. This is measured
              from the bottom of the wheel rim to the wheel-arch. The benefit of
              this method is that tyre choice has no influence on the quoted
              height. A summary of this can be seen here.
            </p>
            <p>
              Still not sure we have the right parts? Not sure which kit is the
              one for you? Then please get in touch, where one of our team will
              ensure you get the right parts for your needs.
            </p>
            <iframe
              title={"Nissan Patrol VIdeo 1"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/rk_03CR8ySk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Patrol VIdeo 2"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/S9eT6vvfnSc"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Patrol VIdeo 3"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Patrol VIdeo 4"}
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "Patrol")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader smaller text={"Lifting your Nissan Patrol?"} />
              <p>Your castor angle will change when you raise it.</p>
              <p>
                Having the correct Castor angle is what keeps your car in a
                straight line and also self centres the steering.
              </p>
              <p>
                Pedders Suspension produce a rubber offset (eccentric) castor
                bush to regain the correct castor angle on your front axle.
              </p>
              <p>
                We recommend that all raised Y60 and Y61 Patrols be fitted with
                Pedders Suspension 5802 Castor correction bushes.
              </p>
              <div>
                <img src={castor} alt="Pedders Suspension 5802 Castor" />
              </div>
              <hr />
              <InfoHeader smaller text={"Castor Bushes (4 pack)"} />
              <Button to={"/details/5802"}>View now</Button>
            </Gray>
            <Gray>
              <InfoHeader smaller text={"Adjustable Drag Links for Patrol"} />
              <p>Patrol Y60 Adjustable Drag Link</p>
              <PhotoLink style={{ marginBottom: "20px" }}>
                <img src={y60} alt="Patrol Y60 Adjustable Drag Link" />
                <Button to={"/details/PDL5001"}>View now</Button>
              </PhotoLink>
              <p>Patrol Y61 Adjustable Drag Link</p>
              <PhotoLink>
                <img src={y61} alt="Patrol Y60 Adjustable Drag Link" />
                <Button to={"/details/PDL5002"}>View now</Button>
              </PhotoLink>
            </Gray>
          </div>
        </InfoGrid>
        <InfoFooter make="Nissan" model="Patrol" />
      </Container>
    </section>
  );
};

export default NissanPatrol;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;

const Button = styled(Link)`
  display: inline-block;
  text-transform: uppercase;
  color: white;
  background-color: var(--red);
  padding: 5px 10px;

  &:hover {
    color: white;
  }
`;

const PhotoLink = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
  }
`;
